import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import { WizardContextProvider } from '../../Services/WizardContext';
import GetWizard from './GetWizard';

loadDOMComponent({
	selector: 'react-get-wizard',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const wizardKey = container.getAttribute('wizardKey');
		const type = container.getAttribute('type');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<WizardContextProvider>
						<GetWizard wizardKey={wizardKey} type={type} />
					</WizardContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
